import { useEffect, useState } from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Download } from "lucide-react";
import CustomerDrawer from "@/components/admin/CustomerDrawer";

export default function AdminCustomers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [drawerId, setDrawerId] = useState(null);
  const API = process.env.REACT_APP_BACKEND_URL;
  useEffect(() => { api.get("/admin/customers", { params: { search: q || undefined } }).then((r) => setItems(r.data)); }, [q]);

  // Same CSV download pattern as AdminOrders: bearer-token fetch → blob → <a download>.
  // The current search filter is forwarded so the admin can export a subset.
  const exportCsv = async () => {
    try {
      const token = localStorage.getItem("xd_admin_token");
      const url = `${API}/api/admin/export/customers.csv${q ? `?search=${encodeURIComponent(q)}` : ""}`;
      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("http " + r.status);
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `audrivio-customers-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
      toast.success("CSV scaricato");
    } catch { toast.error("Errore export CSV"); }
  };

  return (
    <AdminLayout>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-xd-muted">Anagrafica</div>
          <h1 className="font-admin text-2xl font-bold">Clienti</h1>
        </div>
        <div className="flex items-center gap-3">
          <Input placeholder="Cerca…" value={q} onChange={(e) => setQ(e.target.value)} className="w-64" data-testid="customers-search" />
          <button
            type="button"
            onClick={exportCsv}
            data-testid="customers-export-csv"
            className="inline-flex items-center gap-2 bg-xd-dark hover:bg-xd-dark2 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
          >
            <Download className="w-4 h-4" /> Esporta CSV
          </button>
        </div>
      </div>
      <div className="bg-white border border-xd-border rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-xd-light border-b border-xd-border">
            <tr>{["Nome", "Email", "Telefono", "Ordini", "Registrato"].map((h) => <th key={h} className="px-4 py-3 text-left font-mono-tech text-[10px] uppercase tracking-widest text-xd-muted">{h}</th>)}</tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-xd-muted">Nessun cliente</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-b border-xd-border last:border-b-0 hover:bg-slate-50 cursor-pointer" onClick={() => setDrawerId(c.id)} data-testid={`customer-row-${c.id}`}>
                <td className="px-4 py-3 font-medium">{c.name}</td>
                <td className="px-4 py-3">{c.email}</td>
                <td className="px-4 py-3 text-xd-muted">{c.phone}</td>
                <td className="px-4 py-3 font-mono-tech">
                  <span className="text-xd-cyanHover hover:underline">{c.orders_count}</span>
                </td>
                <td className="px-4 py-3 text-xs text-xd-muted">{new Date(c.created_at).toLocaleDateString("it-IT")}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      <CustomerDrawer
        open={!!drawerId}
        onOpenChange={(o) => !o && setDrawerId(null)}
        customerId={drawerId}
      />
    </AdminLayout>
  );
}
